import { CollectionWithHelpers } from './internal/CollectionWithHelpers';
import { PendingOrganization } from 'app/scripts/models/PendingOrganization';

class PendingOrganizationList extends CollectionWithHelpers {
  static initClass() {
    // @ts-expect-error
    this.prototype.model = PendingOrganization;
  }
}
PendingOrganizationList.initClass();

export { PendingOrganizationList };
